export default __webpack_public_path__ + "static/media/save.865eee14.svg";